import React from 'react';
import * as styles from 'common/components/header/Header.scss';

interface SyncDataItem {
    title: string;
    content: string;
    id: number;
}

interface SyncData {
    data: SyncDataItem[];
}

export const SyncData: React.FC<SyncData> = ({ data }) => {
    return (
        <div>
            {data.map((item: any) => {
                return (
                    <div className={styles.dataBox} key={item.id}>
                        <span>{item.title}</span>
                        <strong>{item.content}</strong>
                    </div>
                );
            })}
        </div>
    );
};
